import { useLocation } from 'react-router-dom';
import useAuth from 'src/hooks/useAuth';
import { NON_GUEST_TENANT_MEMBERSHIP_ROLES, type TenantMembershipRole } from 'src/types/auth';

type ActiveTenantRole = {
  role: TenantMembershipRole | undefined;
  /** True when the user holds a non-guest membership role in the active tenant. */
  isStandardMember: boolean;
  /** True when the user's role in the active tenant is 'guest'. */
  isGuest: boolean;
};

export default function useActiveTenantRole(): ActiveTenantRole {
  const { pathname } = useLocation();
  const { user } = useAuth();

  const role = user?.getActiveTenantRole(pathname);
  const isStandardMember = !!role && NON_GUEST_TENANT_MEMBERSHIP_ROLES.includes(role);
  const isGuest = role === 'guest';

  return { role, isStandardMember, isGuest };
}
